import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e28ed51"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "allpageTit"
}
const _hoisted_2 = { class: "pagetit" }
const _hoisted_3 = { class: "r_tits text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left_outlined = _resolveComponent("left-outlined")!

  return (!$setup.isHideTitle)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_left_outlined, {
            onClick: $setup.gobacks,
            style: _normalizeStyle({fontSize: '1.5em',fontWeight: 'bold'})
          }, null, 8, ["onClick", "style"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$et($props.pagetitName)), 1),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "rights", { class: "r_rights" }, undefined, true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}